export default "__VITE_ASSET__07c62d70__"